import { GameId, partition, StoreOfferProduct } from '@common'
import cx from 'classnames'

import { OfferCard } from '@/features/storefronts/_storeBase/card/v2/OfferCard'
import { isNewVisualsEnabled } from '@/features/storefronts/_storeBase/card/v2/shared'

import { OffersHeader } from './OffersHeader'
import { CardOffer } from '../card/CardOffer'

import styles from './Offers.module.scss'

type Props = {
  gameId: GameId
  products: StoreOfferProduct[]
  enableNewVisuals?: GameId[]
}

export function Offers({ products, gameId, enableNewVisuals }: Props) {
  return (
    <div className={cx(styles.offers, styles[gameId])}>
      <OffersHeader gameId={gameId} />
      <OfferCards products={products} gameId={gameId} enableNewVisuals={enableNewVisuals} />
    </div>
  )
}

function OfferCards({ products, gameId, enableNewVisuals }: Props) {
  if (products.length === 0) {
    return null
  }

  if (isNewVisualsEnabled(gameId, enableNewVisuals)) {
    const [multipleProducts, singularProducts] = partition((product) => product.contents.length > 1, products)

    return (
      <>
        {multipleProducts.length > 0 && (
          <div className={cx(styles.offersContainer, styles[gameId])}>
            {multipleProducts.map((offer, index) => (
              <OfferCard key={index} product={offer} enableNewVisuals={enableNewVisuals} />
            ))}
          </div>
        )}
        {singularProducts.length > 0 && (
          <div className={cx(styles.offersContainer, styles[gameId])}>
            {singularProducts.map((product, index) => (
              <OfferCard key={index} product={product} enableNewVisuals={enableNewVisuals} />
            ))}
          </div>
        )}
      </>
    )
  }

  return (
    <div className={styles.offersContainer}>
      {products.map((product, index) => (
        <CardOffer key={index} game={gameId} product={product} />
      ))}
    </div>
  )
}
